import Vue from "vue";
import { Component, Inject, Prop } from "vue-property-decorator";
import FormModalViewer from "@/shared/components/FormModalViewer/FormModalViewer.vue";
import VuePhoneNumberInput from "vue-phone-number-input";
import { FormTemplateService } from "@/modules/FormTemplate/services/FormTemplateService";
import { DataIntelliticks } from "../../models/DataIntelliticks";
import { FormSchema } from "@/shared/models/FormSchema";
import { FormRule } from "@/modules/FormTemplate/models/FormRule";
import { FieldSummary } from "@/modules/FormTemplate/models/FieldSummary";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { Http } from "@status/codes";
import {
  FORM_CONSTANTS,
  FORM_MESSAGES,
  PHONE_TRANSLATIONS,
  VJSF_OPTIONS
} from "@/shared/constants/FormConstants";
import { PhoneSchema } from "@/shared/models/PhoneSchema";
import ModifVJsfInput from "@/shared/components/ModifVJsfInput/ModifVJsfInput.vue";
import {
  FORMS_ACCESS,
  FORMS_CONSTANTS
} from "@/modules/Forms/constants/FormsConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { PhonePayload } from "@/modules/InfoGroup/models/PhonePayload";
import { Forms } from "@/modules/Forms/models/Forms";
import { FormsService } from "@/modules/Forms/services/FormService";
import { FormTemplateData } from "@/modules/FormTemplate/models/FormTemplateData";
import { PostMessageIntelliticks } from "../../models/PostMessageIntelliticks";
import { GROUP_TYPE_CONSTANT } from "../../constants/GroupTypeConstant";
import { QuerySearch } from "@/modules/Forms/models/QuerySearch";
import { AuthService } from "@/modules/Login/services/AuthService";
import { SessionService } from "@/modules/Sessions/services/SessionService";
import { LOAD_DOCUMENT_CONSTANT } from "@/modules/WebViews/LoadDocument/constants/LoadDocumentConstants";
import { SessionIntelliticks } from "../../models/SessionIntelliticks";
import { GENERAL_CONSTANTS } from "@/shared/constants/GeneralConstants";
import { GroupFullSchema } from "@/modules/InfoGroup/models/GroupFullSchema";
import { FORM_TEMP_CONSTANTS } from "@/modules/FormTemplate/constants/FormTemplateConstants";
import { Field } from "@/modules/FormTemplate/models/Field";
import { FormulaField } from "@/shared/models/FormulaField";
import { ListSchema } from "@/modules/List/models/ListSchema";
import { Option } from "@/modules/List/models/Option";
import { TaskService } from "@/modules/Tasks/services/TaskService";
import { SplitFormSchemaByHtmlResult, Utils } from "@/shared/utils/utils";
import HtmlRenderFieldsForm from "@/shared/components/HtmlRenderFieldsForm/HtmlRenderFieldsForm.vue";

@Component({
  name: "ViewIntelliticks",
  components: {
    FormModalViewer,
    VuePhoneNumberInput,
    ModifVJsfInput,
    HtmlRenderFieldsForm
  }
})
export default class ViewIntelliticks extends Vue {
  @Prop() private phoneTypeList!: PhoneSchema[];

  @Inject() formTemplateService!: FormTemplateService;
  @Inject() formsService!: FormsService;
  @Inject() authService!: AuthService;
  @Inject() sessionService!: SessionService;
  @Inject() taskService!: TaskService;

  msgIdView = "";
  bodyWebView: DataIntelliticks = {
    formId: "",
    patientId: "",
    token: "",
    serviceId: "",
    taskId: "",
    required: "false",
    formTempName: "",
    mustPreloadForm: "false",
    mustValidateIfBelongSomeTask: "false"
  };
  SEND_UPDATE_BTN = FORMS_CONSTANTS.BUTTON.SEND_FORM;
  CANCEL_BTN = FORMS_CONSTANTS.BUTTON.CANCEL_FORM;
  cardClass = STYLE_CLASSES.CARD;
  CLOSE_FORM = GROUP_TYPE_CONSTANT.PARENT_MESAGGES.CLOSE_FORM;
  secBtnClass = STYLE_CLASSES.SECONDARY_BTN;
  translations = PHONE_TRANSLATIONS;
  formTemplateData!: FormTemplateData;
  formTemplateId = "";
  taskId = "";
  formId = "";
  patientId = "";
  token = "";
  schema: FormSchema = {
    type: "object",
    allOf: []
  };
  formRules: FormRule[] = [];
  formSummary: FieldSummary[] = [];
  refresh = 0;
  formulaFieldRefreshKey = 0;
  validForm = false;
  options = VJSF_OPTIONS;
  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  model: any = {};
  name = "";
  state = "";
  type = "";
  category = "";
  version = 0;
  dialogPreview = false;
  dateCreated = "";
  dateModified = "";
  clearModel = true;
  serviceId = "";
  seeForm = false;
  showCancelBtn = false;
  sessionId = "";
  groupId = "";
  userId = "";
  sessionTemplateId = "";
  formulaValue = "";
  modelChanged = false;
  htmlSchema: FormSchema = {
    type: "object",
    allOf: []
  };
  htmlFieldsModel: { [key: string]: any } = {};
  separatedSchema: SplitFormSchemaByHtmlResult | undefined;

  created() {
    window.addEventListener("message", this.onPostMessage);
    parent.postMessage({ type: "webview.frame.ready" }, "*");
    const element = document.querySelector("df-messenger");
    if (element) element.remove();
  }

  beforeDestroy() {
    window.removeEventListener("message", this.onPostMessage);
  }

  async onPostMessage(event: PostMessageIntelliticks) {
    if (!event || !event.data || !event.data.msgId || !event.data.body) return;
    console.log("event");
    this.msgIdView = event.data.msgId;
    this.bodyWebView = JSON.parse(event.data.body);
    this.showCancelBtn =
      this.bodyWebView.required && this.bodyWebView.required === "false"
        ? true
        : false;
    this.taskId = this.bodyWebView.taskId ? this.bodyWebView.taskId : "";
    this.patientId = this.bodyWebView.patientId;
    this.sessionId = this.bodyWebView.sessionId
      ? this.bodyWebView.sessionId
      : "";
    this.sessionTemplateId = this.bodyWebView.sessionTemplateId
      ? this.bodyWebView.sessionTemplateId
      : "";
    this.groupId = this.bodyWebView.groupId ? this.bodyWebView.groupId : "";

    if (this.bodyWebView.userLogged) {
      localStorage.setItem("TOKEN", this.bodyWebView.token);
    } else {
      const user = await this.authService.loginByToken(this.bodyWebView.token);
      this.token = await user.user?.getIdToken()!;
      localStorage.setItem("TOKEN", this.token);
    }
    const formTempResponse = await this.formTemplateService.getFormTemplateIdByName(
      this.bodyWebView.formTempName!
    );
    if (formTempResponse.code !== Http.Found) return;

    this.formTemplateId = formTempResponse.message as string;

    this.serviceId = this.bodyWebView.serviceId;
    if (this.bodyWebView?.mustPreloadForm === "true") await this.searchForm();
    this.getFormInformation();
  }

  async searchForm() {
    try {
      const query: QuerySearch = {
        formTemplateId: this.formTemplateId,
        userId: this.patientId,
        loadData: false
      };
      const response = await this.formsService.searchLastFormByUser(query);
      if (response.data) this.formId = response.data;
    } catch (error) {
      this.formId = "";
      return;
    }
  }

  async getFormInformation() {
    try {
      const query: QuerySearch = {
        formTemplateId: this.formTemplateId,
        formId: this.formId,
        loadData: false,
        taskId: this.taskId
      };
      this.refresh++;
      const response = await this.formsService.formServiceInformation(query);
      if (response.code === Http.Found && response.data != null) {
        this.formSummary = response.data.schemaData?.formSummary ?? [];
        this.formRules = response.data.schemaData?.formRules ?? [];
        this.formTemplateData = (response.data
          .formTemplate as any) as FormTemplateData;
        console.log("response.data.schemaData?.schema", response);

        this.separatedSchema = Utils.splitFormSchemaByHtmlDisplay(
          response.data.schemaData?.schema as FormSchema
        );
        console.log("separatedSchema", this.separatedSchema);
        this.htmlSchema = this.separatedSchema.htmlSchema as FormSchema;
        this.schema = this.separatedSchema.vjsfSchema as FormSchema;
        console.log("response", response);

        if (response.data.form && response.data.form.fields)
          this.model = response.data.form.fields;
        this.seeForm = true;
        this.refresh = 1 - this.refresh;
      } else {
        this.clearData();
        this.closeFrame(GROUP_TYPE_CONSTANT.PARENT_MESAGGES.FORM_NOT_FOUND, "");
      }
    } catch (error) {
      console.log("error", error);
      this.closeFrame(GROUP_TYPE_CONSTANT.PARENT_MESAGGES.FORM_ERROR_FOUND, "");
    }
  }

  validateRequired(index: number): string {
    if (
      this.phoneTypeList[index].required == true &&
      !this.phoneTypeList[index].model
    ) {
      return "red";
    } else {
      return "#0B3352";
    }
  }

  onUpdate(payload: PhonePayload, index: number) {
    this.phoneTypeList[index].countryCode = payload.countryCode;
    this.phoneTypeList[index].countryCallingCode = payload.countryCallingCode;
    this.phoneTypeList[index].formattedNumber = payload.formattedNumber || "";
    this.phoneTypeList[index].isValid = payload.isValid;
  }

  checkModel() {
    let modelSize = 0;
    /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
    const newFields: any = {};

    for (const property in this.model) {
      if (this.model[property].length !== 0) {
        const fieldValue = this.formTemplateData.fields.find(
          item => item.key === property
        );

        newFields[property] = {
          indicator: fieldValue?.indicator,
          title: fieldValue?.schema[property].title
        };

        if (
          fieldValue?.type === FORMS_CONSTANTS.FIELD_TYPE.LIST ||
          fieldValue?.visualElement === FORMS_CONSTANTS.FIELD.CHECKBOX
        ) {
          const fieldOptions = fieldValue?.options;

          switch (fieldValue?.visualElement) {
            case FORMS_CONSTANTS.FIELD.RADIO: {
              const listOption = fieldOptions?.find(
                item => item.value === this.model[property]
              );

              newFields[property].titleSelectValue = [
                {
                  title: listOption?.title,
                  value: listOption?.value,
                  type: FORMS_CONSTANTS.FIELD.RADIO
                }
              ];
              newFields[property].scoreSelectValue = listOption?.score;
              newFields[property].value = [listOption?.value];
              newFields[property].listTemplate = fieldValue?.list;

              break;
            }
            case FORMS_CONSTANTS.FIELD.CHECKBOX: {
              const selectedValues = [];
              const titleItems = [];

              if (fieldValue?.type == FORMS_CONSTANTS.FIELD_TYPE.BASIC) {
                for (const checkItem in this.model[property]) {
                  selectedValues.push(this.model[property][checkItem]);
                }
                newFields[property].value = selectedValues;
              } else {
                for (const checkItem in this.model[property]) {
                  const listOption = fieldOptions?.find(
                    item => item.value === this.model[property][checkItem]
                  );
                  selectedValues.push(listOption?.value);
                  titleItems.push({
                    title: listOption?.title,
                    value: listOption?.value,
                    type: FORMS_CONSTANTS.FIELD.CHECKBOX
                  });

                  newFields[property].scoreSelectValue = listOption?.score;
                  newFields[property].titleSelectValue = titleItems;
                  newFields[property].value = selectedValues;
                }
                newFields[property].listTemplate = fieldValue?.list;

                if (this.model[property].length > 1)
                  newFields[property].scoreSelectValue = null;
              }
              break;
            }
            case FORMS_CONSTANTS.FIELD.SELECT: {
              const listOption = fieldOptions?.find(
                item => item.value === this.model[property]
              );
              const listTitle = fieldValue?.schema[property].oneOf?.find(
                item => item.const === this.model[property]
              );

              newFields[property].titleSelectValue = [
                {
                  title: listTitle?.title,
                  value: listOption?.value,
                  type: FORMS_CONSTANTS.FIELD.SELECT
                }
              ];
              newFields[property].scoreSelectValue = listOption?.score;
              newFields[property].value = [listOption?.value];
              newFields[property].listTemplate = fieldValue?.list;

              break;
            }
          }
        } else {
          if (Array.isArray(this.model[property]))
            newFields[property].value = this.model[property];
          else newFields[property].value = [this.model[property]];
        }
        modelSize += 1;
      }
    }

    for (const property in this.htmlFieldsModel) {
      if (Object.prototype.hasOwnProperty.call(newFields, property)) {
        continue;
      }
      const raw = this.htmlFieldsModel[property];
      if (raw === undefined || raw === null) {
        continue;
      }
      if (typeof raw === "string" && raw.length === 0) {
        continue;
      }
      if (Array.isArray(raw) && raw.length === 0) {
        continue;
      }

      const fieldValue = this.formTemplateData.fields.find(
        item => item.key === property
      );
      if (!fieldValue?.schema[property]) {
        continue;
      }

      newFields[property] = {
        indicator: fieldValue.indicator,
        title: fieldValue.schema[property].title
      };
      if (Array.isArray(raw)) {
        newFields[property].value = raw;
      } else {
        newFields[property].value = [raw];
      }
      modelSize += 1;
    }

    return { modelSize, newFields };
  }

  async onSend() {
    if (this.validForm) {
      const modelChecked = this.checkModel();
      const newFields = modelChecked.newFields;
      const modelSize = modelChecked.modelSize;
      const form: Forms = {
        name: this.formTemplateData.name,
        category: this.formTemplateData.category,
        fields: newFields,
        formTemplate: this.formTemplateId,
        versionTemplate: this.formTemplateData.version,
        owner: this.patientId,
        status: FORM_CONSTANTS.STATE.COMPLETE,
        id: this.formId,
        task: this.taskId
      };

      try {
        if (modelSize !== 0) {
          if (this.bodyWebView.mustValidateIfBelongSomeTask == "true") {
            const taskIdResponse = await this.taskService.getTaskIdFromFormTemplate(
              this.formTemplateId,
              this.patientId
            );
            if (taskIdResponse.data && taskIdResponse.code === Http.Found) {
              form.task = taskIdResponse.data;
            }
          }

          const response = await this.formsService.addIntelliticksForm(
            form,
            this.serviceId
          );
          if (response.data && response.code === Http.Ok) {
            if (this.sessionId) {
              this.updateSession(response.data);
            }
            this.closeFrame(
              GROUP_TYPE_CONSTANT.CONFIRM_SAVE_FORM,
              response.data
            );
            this.clearData();
          }
          this.clearData();
        }
      } catch (error) {
        const errorMessage =
          (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
            ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${FORMS_ACCESS.POST} o ${FORMS_ACCESS.PUT}`
            : FORM_MESSAGES.REQUEST_FAILED;

        Snackbar.popError(errorMessage);
      }
    } else {
      Snackbar.popWarning(FORMS_CONSTANTS.SNACKBAR_MSG.EMPTY_FIELDS);
    }
  }

  closeFrame(text: string, data: string) {
    parent.postMessage(
      {
        type: "webview",
        jsonData: JSON.stringify(data || []),
        msgId: this.msgIdView,
        text: text
      },
      "*"
    );
  }

  clearData() {
    this.formSummary = [];
    this.formRules = [];
    this.model = {};
    this.schema = {
      type: "object",
      allOf: []
    };
  }

  async updateSession(formId: string) {
    try {
      const session: SessionIntelliticks = {
        formsIdFilled: [formId],
        serviceId: this.serviceId,
        sessionId: this.sessionId,
        groupId: this.groupId,
        sessionTemplateId: this.sessionTemplateId
      };
      await this.sessionService.updateSession(this.patientId, session);
    } catch (error) {
      this.closeFrame(
        LOAD_DOCUMENT_CONSTANT.PARENT_MESAGGES.LOAD_DOCUMENT_ERROR,
        ""
      );
      return;
    }
  }

  reloadData() {
    if (this.schema instanceof GroupFullSchema) {
      return;
    }
    try {
      const items = (Array.isArray(this.schema.fields) &&
      this.schema.fields.length > 0
        ? this.schema.fields
        : this.formTemplateData?.fields ?? []) as Array<FormulaField | Field>;
      const conditions = this.schema.conditions ? this.schema.conditions : [];
      let formulaOutputUpdated = false;

      items.forEach(field => {
        if (
          field.type === FORM_TEMP_CONSTANTS.FIELD_TYPE.FORMULA &&
          field.formula
        ) {
          this.formulaValue = field.formula.repeat(1);
          let fields = this.formulaValue.match(/\b[0-9A-Za-z_.-]{10}\b/g);
          if (fields !== null) {
            const uniqueSet = new Set(fields);
            fields = JSON.parse(JSON.stringify([...uniqueSet]));

            fields!.forEach(fieldString => {
              if (fieldString in this.model) {
                let newValue = "";
                let score;

                const existList = items.find(
                  item =>
                    item.key === fieldString &&
                    item.type === FORM_TEMP_CONSTANTS.FIELD_TYPE.LIST
                );

                if (existList != undefined) {
                  if (existList.options) {
                    score = existList.options.find(
                      (item: Option) => item.value === this.model[fieldString]
                    )?.score;
                  } else {
                    const oneOf = existList.schema.oneOf;
                    score = Array.isArray(oneOf)
                      ? oneOf.find(
                          (item: ListSchema) =>
                            item.const === this.model[fieldString]
                        )?.score
                      : undefined;
                  }
                }
                if ((score && Number(score)) || score == 0) {
                  newValue = score.toString();
                } else {
                  newValue = this.model[fieldString];
                }
                const regExp = new RegExp(fieldString, "g");
                this.formulaValue = this.formulaValue.replace(
                  regExp,
                  `${newValue}`
                );
              }
            });
            try {
              const result = eval(this.formulaValue);
              if (result && isFinite(result)) {
                Vue.set(this.model, field.key, result.toString());
                formulaOutputUpdated = true;
                this.modelChanged = true;
              }
            } catch (e) {
              delete this.model[field.key];
            }
          }
        }
      });

      conditions.forEach(condition => {
        if (condition.isArray && this.model[condition.key] != undefined) {
          this.model[condition.key].sort();
          this.modelChanged = true;
        }
      });

      if (this.modelChanged) {
        if (formulaOutputUpdated) {
          this.formulaFieldRefreshKey += 1;
        }
        this.modelChanged = false;
      }
    } catch (error) {
      console.error("Error reloading data", error);
    }
  }
}
